import { useProductionSitesContext } from '../redux/ProductionSitesContext';
import { fetchProductionSite } from '../redux/ProductionSitesActions';
import { useDispatch } from 'react-redux';

const ProductionSiteBottomActionCard = () => {
    const dispatch = useDispatch()
    const productionSitesContext = useProductionSitesContext()
    const setSelectedProductionSite = productionSitesContext.setSelectedProductionSite
    const showProductionSiteEditModal = productionSitesContext.uiEvents.showProductionSiteEditModal

    const handleMakeVisibleClick = async () => {
        const siteName = prompt("[DEV ONLY] Enter the exact production site code to reinstate:")
        if (!siteName) return
        try {
            const site = await fetchProductionSite(siteName)(dispatch)
            setSelectedProductionSite(site)
            showProductionSiteEditModal()
        } catch (error) {
            console.error('Error finding site:', error)
        }
    }
    return (
        <div className="d-flex justify-content-between bg-secondary rounded p-3 row">
            <div className="d-flex col">
            </div>
            <button
                className="btn btn-link text-primary"
                onClick={handleMakeVisibleClick}
            >
                Reinstate invisible site
            </button>
        </div>
    )
}

export default ProductionSiteBottomActionCard